export default __webpack_public_path__ + "strongher.77532c4b.svg";